import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Invoice from "./components/Invoice";

export default function OrderConfirmation() {
  const { t } = useTranslation();
  const location = useLocation();
  const { order } = location.state || {};

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="text-center mb-12 no-print">
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 dark:bg-green-900/30 mb-6">
          <svg className="h-10 w-10 text-green-600 dark:text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-4xl font-black text-raya-text-primary mb-4 tracking-tight">
          {t('orderConfirmation.title', 'Order Confirmed!')}
        </h1>
        
        <p className="text-xl text-raya-text-secondary max-w-2xl mx-auto mb-8">
          {t('orderConfirmation.message', 'Thank you for your order. A copy of your receipt is shown below.')}
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
          <button
            onClick={handlePrint}
            className="inline-flex items-center justify-center px-8 py-3 rounded-xl font-bold text-lg transition-all transform bg-raya-accent text-white shadow-lg hover:shadow-xl active:scale-95"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            Print Receipt
          </button>
          
          <Link
            to="/"
            className="inline-flex items-center justify-center px-8 py-3 rounded-xl font-bold text-lg transition-all transform border-2 border-raya-accent text-raya-accent hover:bg-raya-accent hover:text-white active:scale-95"
          >
            {t('orderConfirmation.continueShopping', 'Continue Shopping')}
          </Link>
        </div>
      </div>

      {order ? (
        <Invoice order={order} />
      ) : (
        <div className="bg-raya-card rounded-2xl p-12 text-center border-2 border-dashed border-raya-border">
          <p className="text-raya-text-secondary italic">
            Order details not found. Please check your email for the receipt.
          </p>
        </div>
      )}
    </div>
  );
}
